import { render } from "./GlobalSearchBar.vue?vue&type=template&id=12f4546d"
import script from "./GlobalSearchBar.vue?vue&type=script&lang=js"
export * from "./GlobalSearchBar.vue?vue&type=script&lang=js"

import "./GlobalSearchBar.vue?vue&type=style&index=0&id=12f4546d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__